<p class="bold">Before you invest, it is important that you review the loan agreement that you will enter
  into with the borrower on investment.</p>
<p>
  The loan agreement is entered into between the following parties
</p>
<ul>
  <li>Borrower</li>
  <li>Lenders (including yourself). Minimum number of lenders would be without any cap on maximum.</li>
  <li>Bridge Fintech Solutions Private Limited (company owning and operating www.finzy.com)</li>
</ul>

<p>
  We will fill in following information for each and every loan:
</p>
<ol>
  <li>Loan ID</li>
  <li>Loan Agreement Date</li>
  <li>Borrower Name</li>
  <li>Borrower Address</li>
  <li>Loan Amount</li>
  <li>Schedule 2: would contain details of each lender, amount committed, interest rate and loan amount</li>
</ol>
<p class="bold">
  Please download and review the loan agreement . You can download the loan agreement from <a
        href="https://goo.gl/Uyy8fv" target="_blank">here</a>.
</p>
